import { StatePropertyRef } from '../ExtendableStore';

export interface DuplicateInfo {
    mode: string;
    mappings: Record<string, string>;
}

export const CreateDuplicateInfo = (mode: string = 'none', mappings: Record<string, string> = {}) => ({ mode, mappings });
export const DuplicateInfo = StatePropertyRef<DuplicateInfo>('duplicate', CreateDuplicateInfo());
